// Copyright (c) 2016 Deere & Company

import React, {Component, PropTypes} from 'react';

/* eslint-disable react/prefer-stateless-function */

class PinCellRenderer extends Component {

    render() {

        return (
            <div className='pin-cell-renderer'>
                <a
                    className='product-pin-link'
                    href={`#/products/pin/plate/${encodeURI(this.props.data.id)}`}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    {this.props.value}
                </a>
            </div>
        );

    }

}

PinCellRenderer.displayName = 'PinCellRenderer';
PinCellRenderer.propTypes = {
    data: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default PinCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/duplicate-pin-plate-cell-renderer.js